import React from 'react';
import { TextTag, Breakpoints } from '@volkswagen-onehub/components-core';
import {
  TextAppearance,
  TextSize,
  TextWeight,
  TextLineHeight,
} from '@vw-marketing/us-components';
import { Box, TextBox } from '../Box';
import { Icon } from '../Icon';
import { CTAButton } from './CTAButton';

interface BackButtonProps {
  onBack: () => void;
  label: string;
  ariaLabel?: string;
}

export const BackButton = ({ onBack, label, ariaLabel }: BackButtonProps) => {
  return (
    <Box style={(theme) => ({ marginBottom: theme.size.static150 })}>
      <CTAButton
        tag='button'
        emphasis='tertiary'
        aria-label={ariaLabel}
        onClick={onBack}
        style={{
          '> button': {
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
          },
          '> a': {
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
          },
          '> button > span': {
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
          },
        }}
      >
        <Icon
          name='ArrowLeft'
          ignoreDefaultColor={true}
          style={{
            marginRight: '8px',
          }}
        />

        {label && (
          <TextBox
            appearance={TextAppearance.copy200}
            tag={TextTag.span}
            style={{
              [Breakpoints.default]: {
                fontSize: TextSize.TextSize16,
                fontWeight: TextWeight.regular,
                lineHeight: TextLineHeight.TextLineHeight24,
              },
              [Breakpoints.b1280]: {
                fontSize: TextSize.TextSize16,
                fontWeight: TextWeight.regular,
                lineHeight: TextLineHeight.TextLineHeight24,
              },
            }}
            wrapperStyle={{
              marginTop: '-4px',
            }}
          >
            {label}
          </TextBox>
        )}
      </CTAButton>
    </Box>
  );
};
